const el = {
  shopifyPlan: document.getElementById("shopifyPlan"),
  carriers: document.getElementById("carriers"),
  labels: document.getElementById("labels"),
  usdEur: document.getElementById("usdEur"),
  carriersValue: document.getElementById("carriersValue"),
  labelsValue: document.getElementById("labelsValue"),
  packroosterPrice: document.getElementById("packroosterPrice"),
  shipitPrice: document.getElementById("shipitPrice"),
  packroosterBox: document.getElementById("packroosterBox"),
  shipitBox: document.getElementById("shipitBox"),
  savings: document.getElementById("savings"),
  shipitScan: document.getElementById("shipitScan"),
  shipitCarriers: document.getElementById("shipitCarriers"),
  shipitLabels: document.getElementById("shipitLabels"),
  shipitLocations: document.getElementById("shipitLocations"),
  shipitSmallInvoice: document.getElementById("shipitSmallInvoice"),
  shipmondoPrice: document.getElementById("shipmondoPrice"),
  sendcloudPrice: document.getElementById("sendcloudPrice"),
  shipmondoBox: document.getElementById("shipmondoBox"),
  sendcloudBox: document.getElementById("sendcloudBox"),
};

function selectedRadio(name) {
  return document.querySelector(`input[name="${name}"]:checked`).value;
}

function money(value) {
  return new Intl.NumberFormat("fi-FI", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

function calculatePackrooster(labels, pickupPoints, usdEur) {
  let usd = 0;

  if (labels <= 199) {
    usd = 29 + (0.20 * labels);
  } else if (labels <= 999) {
    usd = 49 + (0.10 * labels);
  } else if (labels <= 3999) {
    usd = 99 + (0.05 * labels);
  } else if (labels <= 5999) {
    usd =
      99 +
      (0.05 * 3999) +
      (0.04 * (labels - 3999));
  } else if (labels <= 7999) {
    usd =
      99 +
      (0.05 * 3999) +
      (0.04 * 2000) +
      (0.03 * (labels - 5999));
  } else {
    usd =
      99 +
      (0.05 * 3999) +
      (0.04 * 2000) +
      (0.03 * 2000) +
      (0.02 * (labels - 7999));
  }

  if (!pickupPoints) {
    usd -= 29;
  }

  return Math.max(0, usd) * usdEur;
}

function calculateShipit(
  plan,
  carriers,
  labels,
  scanPack,
  multiLocation,
  usdEur
) {
  let scanPackUsd = 0;

  if (scanPack) {
    const planPricesUsd = {
      basic: 9.90,
      grow: 19.90,
      advanced: 29.90,
      plus: 39.90
    };

    scanPackUsd = planPricesUsd[plan];
  }

  let carrierFeeEur;
  let labelUnitPriceEur;

  if (carriers === 1) {
    carrierFeeEur = 9.90;
    labelUnitPriceEur = 0.20;
  } else if (carriers <= 3) {
    carrierFeeEur = 49.90;
    labelUnitPriceEur = 0.16;
  } else {
    carrierFeeEur = 99.90;
    labelUnitPriceEur = 0.14;
  }

  const labelFeeEur = labels * labelUnitPriceEur;

  // Shipitin euroissa laskutettavat tuotteet
  const euroBilledMonthly = carrierFeeEur + labelFeeEur;

  // Shipit laskuttaa kaksi kertaa kuukaudessa
  const euroBilledPerInvoice = euroBilledMonthly / 2;

  // Pienlaskutuslisä 3,50 € / lasku, jos lasku on alle 50 €
  const smallInvoiceFeePerInvoice =
  euroBilledPerInvoice < 50 ? 3.50 : 0;

  const smallInvoiceFeeEur =
  smallInvoiceFeePerInvoice * 2;

  const multiLocationUsd = multiLocation ? 10 : 0;

  const scanPackEur = scanPackUsd * usdEur;
  const multiLocationEur = multiLocationUsd * usdEur;

  return {
    total:
      scanPackEur +
      carrierFeeEur +
      labelFeeEur +
      multiLocationEur +
      smallInvoiceFeeEur,

    scanPackEur,
    carrierFeeEur,
    labelFeeEur,
    multiLocationEur,
    smallInvoiceFeeEur
  };
}

function calculateShipmondo(carriers, labels) {
  // Kuukausimaksu kuljetusyhtiöiden määrän perusteella
  const monthlyFee = carriers <= 2 ? 14 : 36;

  let remaining = labels;
  let labelFee = 0;

  // Ensimmäiset 499 kpl: 0,08 €
  let amount = Math.min(remaining, 499);
  labelFee += amount * 0.08;
  remaining -= amount;

  // Seuraavat 1499 kpl: 0,07 €
  if (remaining > 0) {
    amount = Math.min(remaining, 1499);
    labelFee += amount * 0.07;
    remaining -= amount;
  }

  // Seuraavat 1999 kpl: 0,06 €
  if (remaining > 0) {
    amount = Math.min(remaining, 1999);
    labelFee += amount * 0.06;
    remaining -= amount;
  }

  // Seuraavat 1999 kpl: 0,05 €
  if (remaining > 0) {
    amount = Math.min(remaining, 1999);
    labelFee += amount * 0.05;
    remaining -= amount;
  }

  // Seuraavat 1999 kpl: 0,04 €
  if (remaining > 0) {
    amount = Math.min(remaining, 1999);
    labelFee += amount * 0.04;
    remaining -= amount;
  }

  // Loput: 0,03 €
  if (remaining > 0) {
    labelFee += remaining * 0.03;
  }

  return {
    total: monthlyFee + labelFee,
    monthlyFee,
    labelFee
  };
}

function calculateSendcloud(carriers, labels) {
  let monthlyFee;
  let labelFee;
  let labelUnitPrice;
  let tier;

  // Hintaporras 4:
  // Yli 1625 osoitekorttia
  // 219 €/kk + kaikki osoitekortit 0,10 €/kpl
  if (labels > 1625) {
    tier = 4;
    monthlyFee = 219;
    labelUnitPrice = 0.10;
    labelFee = labels * 0.10;
  }

  // Hintaporras 3:
  // Yli 5 kuljetusyhtiötä TAI yli 1000 osoitekorttia
  // Ensimmäiset 1000 osoitekorttia 0,11 €/kpl
  // Yli 1000 menevät 0,26 €/kpl
  else if (carriers > 5 || labels > 1000) {
    tier = 3;
    monthlyFee = 109;

    if (labels <= 1000) {
      labelFee = labels * 0.11;
    } else {
      labelFee =
        (1000 * 0.10) +
        ((labels - 1000) * 0.26);
    }

    // Ei yhtä yksikköhintaa porrastetun hinnoittelun vuoksi
    labelUnitPrice = null;
  }

  // Hintaporras 2:
  // 4-5 kuljetusyhtiötä TAI 401-1000 osoitekorttia
  else if (carriers >= 4 || labels > 400) {
    tier = 2;
    monthlyFee = 109;
    labelUnitPrice = 0.11;
    labelFee = labels * 0.11;
  }

  // Hintaporras 1:
  // 1-3 kuljetusyhtiötä JA enintään 400 osoitekorttia
  else {
    tier = 1;
    monthlyFee = 35;
    labelUnitPrice = 0.12;
    labelFee = labels * 0.12;
  }

  return {
    total: monthlyFee + labelFee,
    monthlyFee,
    labelFee,
    labelUnitPrice,
    tier
  };
}

function updateCalculator() {
  const plan = el.shopifyPlan.value;
  const carriers = Number(el.carriers.value);
  const labels = Number(el.labels.value);

  const pickupPoints =
    selectedRadio("pickupPoints") === "yes";

  const scanPack =
    selectedRadio("scanPack") === "yes";

  const multiLocation =
    selectedRadio("multiLocation") === "yes"; 

  const usdEur =
    Number(el.usdEur.value) || 0;

  el.carriersValue.textContent =
    carriers;

  el.labelsValue.textContent =
    labels.toLocaleString("fi-FI");

  const packrooster =
    calculatePackrooster(
      labels,
      pickupPoints,
      usdEur
    );

    const shipmondo = calculateShipmondo(
      carriers,
      labels
    );

    const sendcloud = calculateSendcloud(
      carriers,
      labels
    );    

  const shipit =
    calculateShipit(
      plan,
      carriers,
      labels,
      scanPack,
      multiLocation,
      usdEur
    );

  el.packroosterPrice.textContent =
    money(packrooster);

  el.shipitPrice.textContent =
    money(shipit.total);

  el.shipitScan.textContent =
    money(shipit.scanPackEur);

  el.shipitCarriers.textContent =
    money(shipit.carrierFeeEur);

  el.shipitLabels.textContent =
    money(shipit.labelFeeEur);

  el.shipitLocations.textContent =
    money(shipit.multiLocationEur);

  el.shipitSmallInvoice.textContent =
    money(shipit.smallInvoiceFeeEur);     
    
  el.shipmondoPrice.textContent =
    money(shipmondo.total);

  el.sendcloudPrice.textContent =
    money(sendcloud.total);
/*
  el.packroosterBox.classList.remove("best");
  el.shipitBox.classList.remove("best");

  const difference =
    Math.abs(shipit.total - packrooster);

  if (packrooster < shipit.total) {
    el.packroosterBox.classList.add("best");

    el.savings.textContent =
      `Packrooster Shipping on ${money(difference)} / kk edullisempi.`;

  } else if (shipit.total < packrooster) {
    el.shipitBox.classList.add("best");

    el.savings.textContent =
      `Shipit on ${money(difference)} / kk edullisempi.`;

  } else {
    el.savings.textContent =
      "Kuukausihinta on molemmissa sama.";
  }
  */
 
  const services = [
  {
    name: "Packrooster Shipping",
    price: packrooster,
    box: el.packroosterBox
  },
  {
    name: "Shipmondo",
    price: shipmondo.total,
    box: el.shipmondoBox
  },
  {
    name: "Sendcloud",
    price: sendcloud.total,
    box: el.sendcloudBox
  },
  {
    name: "Shipit",
    price: shipit.total,
    box: el.shipitBox
  }
];

// Poista vanhat korostukset
services.forEach(service => {
  service.box.classList.remove("best");
});

// Selvitä halvin
const cheapestPrice = Math.min(
  ...services.map(service => service.price)
);

const cheapestServices = services.filter(
  service => Math.abs(service.price - cheapestPrice) < 0.001
);

// Korosta halvin / halvimmat
cheapestServices.forEach(service => {
  service.box.classList.add("best");
});

if (cheapestServices.length === 1) {
  const cheapest = cheapestServices[0];

  const otherPrices = services
    .filter(service => service !== cheapest)
    .map(service => service.price);

  const nextCheapest =
    Math.min(...otherPrices);

  const difference =
    nextCheapest - cheapest.price;

  el.savings.textContent =
    `${cheapest.name} on halvin vaihtoehto. ` +
    `Ero seuraavaksi edullisimpaan on ${money(difference)} / kk.`;
} else {
  el.savings.textContent =
    `${cheapestServices
      .map(service => service.name)
      .join(" ja ")} ovat yhtä edullisia.`;
}
  
}

document
  .querySelectorAll("input, select")
  .forEach(input => {
    input.addEventListener(
      "input",
      updateCalculator
    );

    input.addEventListener(
      "change",
      updateCalculator
    );
  });

updateCalculator();